<template>
  <section class="text__edit">
    <quill-editor style="height: 200px" ref="myTextEditor" v-model="editData.data"
                  :options="editorOption"></quill-editor>
  </section>
</template>

<script type="text/babel">
  import { quillEditor } from 'vue-quill-editor'
  import Quill from 'quill'

  export default {
    name: 'text-edit',
    components: {
      quillEditor
    },
    props: {
      editData: {}
    },
    computed: {
      editor () {
        return this.$refs.myTextEditor.quill;
      }
    },
    data () {
      return {
        editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'size': ['10px', '12px', false, '16px', '18px', '20px', '24px', '28px', '32px'] }],
              [{ 'color': [] }, { 'background': [] }],
              ['clean']
            ]
          }
        }
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        const Size = Quill.import('attributors/style/size');
        Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px'];
        Quill.register(Size, true);
      }
    }
  }
</script>

<style lang="scss">
  .text__edit {
    min-height: 242px;

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="10px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
      content: '10px';
      font-size: 10px;
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
      content: '12px';
      font-size: 12px;
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
      content: '14px';
      font-size: 14px;
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
      content: '14px';
      font-size: 14px;
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
      content: '16px';
      font-size: 16px;
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
      content: '18px';
      font-size: 18px;
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
      content: '20px';
      font-size: 20px;
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="22px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22px"]::before {
      content: '22px';
      font-size: 22px;
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
      content: '24px';
      font-size: 24px;
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="26px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="26px"]::before {
      content: '26px';
      font-size: 26px;
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="28px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28px"]::before {
      content: '28px';
      font-size: 28px;
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before {
      content: '30px';
      font-size: 30px;
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
      content: '32px';
      font-size: 32px;
    }
  }
</style>
